import React from 'react';

// USP 박스 — 사장님 확인된 차별점: "모든 세차에 스팀이 기본".
// Hero 직후 / Price CTA 직전에 배치해 가격 보기 전에 가치 각인.
// 카피 톤 = B(가치 강조형). 절대 표현 사용 가능(운영 100% 보장 확인됨, 2026-05-12).
export default function SteamDifferentiator() {
  const points = [
    { icon: '✓', title: '도장면 흠집 없음', desc: '비접촉 고온 스팀 세정' },
    { icon: '✓', title: '친환경 세차', desc: <>스팀으로 초기 세정<br />친환경 약품으로 마무리 세정</> },
    { icon: '✓', title: '실내까지 살균 효과', desc: '고온 스팀이 시트·매트 사이까지' },
  ];

  return (
    <section style={{
      padding: 'clamp(28px, 5vw, 56px) 0',
      background: 'var(--bg)',
      borderBottom: '1px solid var(--border)',
    }}>
      <div className="container">
        <div className="steam-diff-card">
          <div className="steam-diff-header">
            <span className="steam-diff-badge">왜 KOA DETAILING는 다른가</span>
            <h2 className="steam-diff-headline">
              스팀은 옵션이 아닙니다
              <br />
              <span className="steam-diff-accent">모든 세차에 스팀이 기본입니다</span>
            </h2>
            <p className="steam-diff-sub">
              일반 손세차장은 거품 + 물세차로 끝납니다.
              <br />
              {/* 'KOA DETAILING은' 다음 강제 줄바꿈 — 모든 화면에서 정확히 2줄로 */}
              KOA DETAILING은
              <br />
              고온 스팀 공정이 포함됩니다.
            </p>
          </div>
          <div className="steam-diff-points">
            {points.map((p, i) => (
              <div key={i} className="steam-diff-point">
                <span className="steam-diff-check">{p.icon}</span>
                <div>
                  <strong>{p.title}</strong>
                  <div className="steam-diff-point-desc">{p.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
